import React, { Component } from 'react';
import {ToastContainer, ToastStore} from 'react-toasts';

import RestorePasswordFormStyles from './components/RestorePasswordForm.css';
import { Button, FormGroup, Label, Input } from 'reactstrap';

import WarningMessage from './components/WarningMessage';

import utilities from './components/Utilities';
let Utilities = new utilities();

class ResendActivationLink extends Component {

    constructor(props) {

        super(props);

        this.state = {
            email: "",
            loginStatusMsgSuccess: null,
            loginStatusMsg: null
        };

    }

    onInputChange = (e) => {

        let modifiedField = e.target.id;
        let modifiedFieldValue = e.target.value;

        let state = {...this.state};
        state[modifiedField] = modifiedFieldValue;

        this.setState(state);

    }

    componentDidMount() {
        document.title = window.globalVars.pageTitleBefore + "Resend Activation Link" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    requestResend = () => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/resend/activation",
            data: {
                email: this.state.email
            },
            then: function(res) {

                if (res.data.success !== true) {
                    this.setState({
                        loginStatusMsg: (res.data.data || "Unexpected Error"),
                        loginStatusMsgSuccess: false,
                    })
                } else {
                    // ToastStore.success(res.data.data, 60000);
                    this.setState({
                        loginStatusMsg: res.data.data,
                        loginStatusMsgSuccess: true
                    })
                }

            }.bind(this),
            catch: function(e) {

                this.setState({
                    loginStatusMsg: "Unexpected Error",
                    loginStatusMsgSuccess: false
                })

            }.bind(this)
        })

    }

    render() {

        return (
            <div className="restore-password-container">
                <div className="main-container">
                    <div className="restore-password login">
                        <div>
                            <h1>Resend activaton email</h1>
                            <div className="form">
                                <div className="form-group">
                                    <label for="email">Email</label>
                                    <input onBlur={this.onInputChange} defaultValue={this.state.email} type="email" name="email" id="email" placeholder="Email" />
                                </div>
                                <WarningMessage message={this.state.loginStatusMsg} success={this.state.loginStatusMsgSuccess} />
                                <div className="options">
                                    <div className="clearfix">
                                        <button className="login-btn" onClick={this.requestResend}>
                                            Resend
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_CENTER}/>
            </div>
        );

    }

}

export default ResendActivationLink;



// WEBPACK FOOTER //
// ./src/ResendActivationLink.js